import React from 'react'

import { Link } from 'react-router-dom'

import Icon from 'Pods/Shared/Icon/Icon'
import MetaDataHelmet from 'Pods/Shared/MetaDataHelmet'
import withRouter from 'Pods/Shared/withRouter'

import ApplicationForm from './Components/ApplicationForm'
import LockedForGuestSection from './Components/LockedForGuestSection'
import ProjectDetails from './Components/ProjectDetails'
import Loader from '../../Shared/Loader'

class ProjectApplication extends React.Component {
  constructor() {
    super()

    this.state = {
      job: {},
      attachments: [],
      isDataFetched: false,
    }

    this.fetchJob = this.fetchJob.bind(this)
    this.onFetchJobSuccess = this.onFetchJobSuccess.bind(this)
    this.onFetchJobFailure = this.onFetchJobFailure.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()
    this.fetchJob()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchJob() {
    axios.get(`/api/internal/jobs/${this.props.match.params.id}`)
      .then(this.onFetchJobSuccess)
      .catch(this.onFetchJobFailure)
  }

  onFetchJobSuccess(response) {
    this.setState({
      job: response.data.data,
      attachments: response.data.included,
      isDataFetched: true,
    })
  }

  onFetchJobFailure() {
    App.events.publish('app:notification:flash:error', 'This 3D Project is no longer available.')
    setTimeout(() => window.location.href = '/3d-modeling-jobs/browse', 1000)
  }

  render() {
    const attachments = this.state.attachments
    const images = attachments && attachments.length > 0 && attachments.filter(file => file.attributes.contentType === 'image')
    const files = attachments && attachments.length > 0 && attachments.filter(file => file.attributes.contentType === 'file')

    return (
      <div className="tabs-content">
        {this.state.isDataFetched ? (
          <div className="container-fixed">
            <MetaDataHelmet
              title={`${this.state.job.attributes.title} | 3D Modeling Jobs`}
              description={this.state.job.attributes.description}
            />
            <Link to={{ pathname: '/3d-modeling-jobs/browse' }} className="btn btn-outline-default btn-sm">
              <Icon type={['far', 'angle-left']} /> Back to 3D Projects
            </Link>
            <div className="card project-application-form">
              <ProjectDetails
                data={this.state.job.attributes}
                jobId={this.props.match.params.id}
                images={images}
                files={files}
                skillsFilterOptions={this.props.skillsFilterOptions}
                softwareFilterOptions={this.props.softwareFilterOptions}
              />
              {this.props.isSignedIn ? (
                <ApplicationForm
                  jobBudget={this.state.job.attributes.budget}
                  designerRoyaltyRate={this.state.job.attributes.designerRoyaltyRate}
                  trackingId={this.state.job.id}
                />
              ) : (
                <LockedForGuestSection />
              )}
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    )
  }
}

export default withRouter(ProjectApplication)
